import { get, post } from './axios.js'

/**
 * 알람 발송 목록 조회 - /batch/alarmRsltList
 * @param {object} params
 * @property {string} params.alarm_id
 * @property {string} params.sales_id
 * @property {string} params.rst_yn
 * @property {string} params.fr_date
 * @property {string} params.to_date
 * @property {string} params.page_count
 * @property {string} params.unit_count
 * @returns
 */
export async function alarmRsltList(params = {}) {
  try {
    const result = await post('/batch/alarmRsltList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 배치 프로시져 목록 조회 - /batch/procCronList
 * @param {object} params
 * @property {string} params.proc_nm
 * @property {string} params.proc_desc
 * @property {string} params.success_yn
 * @property {string} params.use_yn
 * @property {string} params.page_count
 * @property {string} params.unit_count
 * @returns
 */
export async function procCronList(params = {}) {
  try {
    const result = await post('/batch/procCronList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 스케쥴러 목록 조회 - /batch/schdLogList
 * @param {object} params
 * @property {string} params.sch_id
 * @property {string} params.success_yn
 * @property {string} params.fr_date
 * @property {string} params.to_date
 * @property {string} params.page_count
 * @property {string} params.unit_count
 * @returns
 */
export async function schdLogList(params = {}) {
  try {
    const result = await post('/batch/schdLogList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

// 아래 목록 확인 요망
export async function procCronSelect(params = {}) {
  try {
    const result = await post('/batch/procCronSelect', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}
export async function procCronEdit(params = {}) {
  try {
    const result = await post('/batch/procCronEdit', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}
export async function totalList(params = {}) {
  try {
    const result = await post('/salesHist/totalList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

export async function totalListExcel(params = {}) {
  try {
    const result = await post('/salesHist/totalListExcel', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

export async function typeSalesCeo(params = {}) {
  try {
    const result = await post('/salesHist/typeSalesCeo', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

export async function typeSalesCeoExcel(params = {}) {
  try {
    const result = await post('/salesHist/typeSalesCeoExcel', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

export async function typeSalesId(params = {}) {
  try {
    const result = await post('/salesHist/typeSalesId', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

export async function typeSalesIdExcel(params = {}) {
  try {
    const result = await post('/salesHist/typeSalesIdExcel', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}
export async function getErPordList(params = {}) {
  try {
    const result = await post('/salesHist/getErPordList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}